import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { PlanningService } from '../../providers/planning.service';
import { UserService } from '../../providers/user.service';
import { IUserListResponse } from '../../../typings/api';
import { Observable } from 'rxjs/Observable';
import { IPlanningUser, IPlanning } from '../../../typings/timetracker/timetracker';
import { keys, map, size } from 'lodash';
import { MatStepper } from '@angular/material';

/**
 * Generated class for the PlanningCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-planning-create',
  templateUrl: 'planning-create.html',
})
export class PlanningCreatePage implements OnInit {

  dateAndtime = moment().add( 1, 'day' ).set( 'hours', 7 ).set( 'minutes', 0 ).format();
  details$: Observable<IPlanning>;
  scheduled: { [ key: number ]: boolean; } = {};
  nrOfUsersScheduled: number = 0;
  users$: Observable<IUserListResponse>;
  validateDateFormGroup: FormGroup;
  selectUsersFormGroup: FormGroup;

  @ViewChild('stepper') private myStepper: MatStepper;

  ngOnInit() {

    this.validateDateFormGroup = this.formBuilder.group({
      dateTime: ['', Validators.required]
    });
    this.selectUsersFormGroup = this.formBuilder.group({
      users: ['', Validators.required]
    });
  }

  createPlanning(): void {
    const dateTime = moment( this.dateAndtime ).startOf( 'minute' );
    this.$planningAPI.dispatchCreatePlanning( dateTime.isoWeekYear(), dateTime.isoWeek(), dateTime.isoWeekday(), dateTime.format() )
    .then( () => {
      this.validateDateFormGroup.get( 'dateTime' ).setValue( true );
      this.$userAPI.dispatchUserFetchAll( 1000, 0, 'employee_nr', 'ASC' );
      this.myStepper.next();
    } )
    .catch( ( error ) => {
      console.error( '[PLANING-CREATE]', error );
    } );
  }

  toggleScheduled( userId: number ) {
    for( var key in this.scheduled ){
      if( this.scheduled.hasOwnProperty( key ) && this.scheduled[ key ] === false ) {
       delete this.scheduled[ key ];
      }
    }
    this.nrOfUsersScheduled = size( keys( this.scheduled ) );
  }

  inviteUserToPlanning() {
    this.details$.take( 1 ).subscribe( ( planning ) => {
      if ( planning ) {
        this.$planningAPI.dispatchAddUsersToPlanning( planning.id, ( map( keys( this.scheduled ), ( keyString ) =>  { return {
          'user_id': parseInt( keyString, 10 )
        } } ) as IPlanningUser[]  ) )
        .then( ( response ) => {
          this.selectUsersFormGroup.get( 'users' ).setValue( true );
          this.myStepper.next();
        } )
        .catch( ( error ) => {
          console.error( '[PLANING-CREATE]', error );
        } );
      }
    } );
  }

  nextWithoutAction() {
    setTimeout( () => {
      this.selectUsersFormGroup.get( 'users' ).setValue( true );
      this.myStepper.next();
    });
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private $userAPI: UserService,
    private $planningAPI: PlanningService ) {
      this.users$ = this.$userAPI.selectUserFetchAll();
      this.details$ = this.$planningAPI.selectPlanningFetch();
  }
}



// WEBPACK FOOTER //
// ./src/pages/planning-create/planning-create.ts